import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Toaster } from "@/components/ui/toaster";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import RequireAuth from "@/components/auth/RequireAuth";

import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import ListingDetail from "@/pages/ListingDetail";
import PostAd from "@/pages/PostAd";
import Favorites from "@/pages/Favorites";
import SearchResults from "@/pages/SearchResults";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Profile from "@/pages/Profile";
import PublicProfile from "@/pages/PublicProfile";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminTheme from "@/pages/admin/AdminTheme";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminModeration from "@/pages/admin/AdminModeration";

function Shell({ children }) {
  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

// Handles Google OAuth redirect (#session_id=...) synchronously
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <Shell><AuthCallback /></Shell>;
  }
  return (
    <Routes>
      <Route path="/" element={<Shell><Home /></Shell>} />
      <Route path="/categorie/:categoryId" element={<Shell><CategoryPage /></Shell>} />
      <Route path="/anunt/:id" element={<Shell><ListingDetail /></Shell>} />
      <Route path="/anunt/:id/editare" element={<Shell><RequireAuth><PostAd /></RequireAuth></Shell>} />
      <Route path="/adauga-anunt" element={<Shell><RequireAuth><PostAd /></RequireAuth></Shell>} />
      <Route path="/favorite" element={<Shell><Favorites /></Shell>} />
      <Route path="/cauta" element={<Shell><SearchResults /></Shell>} />
      <Route path="/login" element={<Shell><Login /></Shell>} />
      <Route path="/inregistrare" element={<Shell><Register /></Shell>} />
      <Route path="/auth/callback" element={<Shell><AuthCallback /></Shell>} />
      <Route path="/profil" element={<Shell><RequireAuth><Profile /></RequireAuth></Shell>} />
      <Route path="/utilizator/:userId" element={<Shell><PublicProfile /></Shell>} />

      <Route path="/admin/login" element={<Shell><AdminLogin /></Shell>} />
      <Route path="/admin" element={<Shell><AdminLayout /></Shell>}>
        <Route index element={<AdminDashboard />} />
        <Route path="theme" element={<AdminTheme />} />
        <Route path="categories" element={<AdminCategories />} />
        <Route path="moderation" element={<AdminModeration />} />
      </Route>

      <Route path="*" element={<Shell><Home /></Shell>} />
    </Routes>
  );
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster />
    </AppProvider>
  );
}

export default App;
